import React from "react";
import "./spinner.styles.scss";

const Spinner = () => (
  <div className="cssload-container">
    <div className="cssload-whirlpool"></div>
  </div>
);
export default Spinner;
